import { useWindowSize } from 'usehooks-ts';

export const useMediaQuery = () => {
  const { width } = useWindowSize();
  return { isDesktop: width > 1000, isMobile: width <= 450 };
};
